import { PropsWithChildren, SVGProps, useContext } from "react"
import { CanvasControlsContext } from "@/components/canvas-controls/CanvasControlsContext"

interface EllipseProps extends PropsWithChildren<SVGProps<SVGEllipseElement>> {
	cx: number
	cy: number
	rx: number
	ry: number
	angle?: number
	outline?: string
}

export const Ellipse = ({
	cx,
	cy,
	rx,
	ry,
	angle = 0,
	outline = "rgba(0,0,0,0.3)",
	children,
	...props
}: EllipseProps) => {
	const { parentWidth, parentHeight } = useContext(CanvasControlsContext)

	cx *= parentWidth
	cy *= parentHeight
	rx *= parentWidth
	ry *= parentHeight

	const transform = `rotate(${-angle} ${cx} ${cy})`

	return (
		<CanvasControlsContext.Provider
			value={{
				parentX: cx - rx,
				parentY: cy - ry,
				parentWidth: rx * 2,
				parentHeight: ry * 2,
			}}
		>
			<g transform={transform}>
				{outline !== "none" && (
					<ellipse
						cx={cx}
						cy={cy}
						rx={rx}
						ry={ry}
						stroke={outline}
						strokeWidth={3}
						className="pointer-events-none"
					/>
				)}
				<ellipse
					cx={cx}
					cy={cy}
					rx={rx}
					ry={ry}
					stroke="white"
					strokeWidth={1}
					{...props}
				/>
				{children}
			</g>
		</CanvasControlsContext.Provider>
	)
}
